import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { columns } from './services-grid-columns';
import { servicesApiKeyStore } from '../../../../api/masters/services-api-key-store';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { useLoadData } from '../../../../hooks/useLoadData';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { ApiResponse } from '../../../../models/api-response';
import { Service } from '../../../../models/masters/service';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { useSaveData } from '../../../../hooks/useSaveData';
import { useEffect, useState } from 'react';
import { State } from '@progress/kendo-data-query';
import useDebounce from '../../../../hooks/use-debounce';
import { Project } from '../../../../models/project';

interface ProjectsTabProps {
  customerID: number;
}

const DEFAULT_GROUP = [
  {
    field: 'serviceGroupName',
  },
];

export const ServicesTab = ({ customerID }: ProjectsTabProps) => {
  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout,
  } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('Customer Details', 'Service'));

  const {
    isLoading,
    data: Services,
    refetch,
  } = useLoadData<ApiResponse<Service[]>>(servicesApiKeyStore.getServiceCustomerMappings(customerID));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredServices, setFilteredServices] = useState<Service[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredServicetList = Services?.data?.filter((Project) =>
      Object.values(Project).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredServices(filteredServicetList || []);
  }, [debouncedSearchTerm, Services?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'Service',
      pageName: 'Customer Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'Service',
      pageName: 'Customer Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  return (
    <SiTrackGrid
      fileTitle='customer_service'
      columns={columns}
      dataItemKey="serviceID"
      // queryConfig={servicesApiKeyStore.getServiceCustomerMappings(customerID)}
      // defaultGroup={DEFAULT_GROUP}
      actionPermissions={{
        export: UserPermissionName.DOWNLOAD_GRID,
      }}
      // -----------------Grid Layout-------
      dataItems={filteredServices || []}
      reorderable
      handleSearch={handleInputChange}
      handleSaveLayout={handleSaveLayout}
      isSaveLayout={true}
      gridConfigFromApi={gridConfig}
      handleResetLayout={handleResetLayout}
    // -----------------Grid Layout-------
    />
  );
};
